export const CALENDLY_URL = "https://calendly.com/giosgarbi98/30min";
export const EMAIL = "giorgia@studionoom.it";
export const INSTAGRAM_URL = "https://instagram.com/studionoom";

export const translations = {
  it: {
    nav: {
      links: [
        { id: "#valore", num: "01", label: "Visione" },
        { id: "#metodo", num: "02", label: "Metodo" },
        { id: "#servizi", num: "03", label: "Servizi" },
        { id: "#processo", num: "04", label: "Processo" },
        { id: "#portfolio", num: "05", label: "Portfolio" },
      ],
      cta: "Prenota una call",
    },
    hero: {
      tag: "Studio di brand design strategico · Modena",
      lines: [
        [{ t: "Trasformo identità" }],
        [{ t: "in immagini" }],
        [{ t: "che " }, { t: "parlano.", a: true }],
      ],
      sub: "Per studi professionali, attività di servizi e brand lifestyle che non cercano decorazione, ma un'identità capace di aumentare il valore percepito sul mercato.",
      primary: "Prenota una Call Conoscitiva",
      secondary: "Scopri il metodo",
      meta: "Brand identity · Posizionamento · Direzione creativa",
      scroll: "Scorri per esplorare",
    },
    marquee: [
      "Strategia visiva",
      "Valore percepito",
      "Cura sartoriale",
      "Fiducia",
      "Metodo",
      "Consapevolezza",
      "Riconoscibilità",
    ],
    manifesto: {
      label: "[ Capitolo 01 — Il problema ]",
      lines: [
        [{ t: "Una comunicazione" }],
        [{ t: "disordinata " }, { t: "svaluta", a: true }],
        [{ t: "il tuo prezzo." }],
      ],
      body: "Il mercato giudica in pochi secondi. Se l'immagine è frammentata — un logo improvvisato, social incoerenti, materiali scollegati — il valore reale del tuo lavoro non arriva a chi guarda. E il prezzo ne paga le conseguenze.",
      body2: "Il mio lavoro è portare ordine: un'identità strategica che restituisce autorevolezza, rende il brand riconoscibile e sostiene il valore di ciò che offri.",
      before: {
        title: "Prima",
        items: [
          "Immagine frammentata e improvvisata",
          "Percezione amatoriale, anche se sei un professionista",
          "Prezzi che devi giustificare a fatica",
        ],
      },
      after: {
        title: "Dopo — con studio noom",
        items: [
          "Identità strategica, coerente ovunque",
          "Autorevolezza immediata agli occhi del cliente",
          "Un premium price sostenibile e credibile",
        ],
      },
      quote: "Il branding non è decorazione. È strategia di business che aumenta il valore percepito.",
    },
    values: {
      label: "[ Capitolo 02 — Perché scegliermi ]",
      heading: "Quattro pilastri, un solo metodo.",
      items: [
        {
          title: "Ascolto",
          desc: "La fiducia nasce dall'ascolto e dalla trasparenza. Mi prendo il tempo di comprendere davvero chi ho davanti, prima di disegnare una sola linea.",
        },
        {
          title: "Metodo strutturato",
          desc: "Niente improvvisazione: un processo chiaro, spiegato in modo semplice, che guido passo dopo passo dall'inizio alla consegna.",
        },
        {
          title: "Cura del dettaglio",
          desc: "Ogni brand merita attenzione sartoriale, indipendentemente dalla sua dimensione. Nessun progetto viene mai lasciato solo.",
        },
        {
          title: "Strategia prima dell'estetica",
          desc: "Il bello senza direzione non vende. Prima definiamo chi sei e a chi parli, poi come apparire.",
        },
      ],
    },
    services: {
      label: "[ Capitolo 03 — Servizi ]",
      heading: "Tre modi per lavorare insieme.",
      cta: "Richiedi informazioni",
      items: [
        {
          tag: "Da zero",
          title: "Brand Identity Completa",
          desc: "Un'identità intera, costruita dalle fondamenta: strategia, sistema visivo e linee guida pronte a durare nel tempo.",
          items: [
            "Posizionamento & strategia",
            "Logo system & tipografia",
            "Palette e linee guida",
            "Stationery & asset digitali",
          ],
        },
        {
          tag: "Rebrand",
          title: "Brand Refresh Strategico",
          desc: "Per brand già avviati che sentono l'immagine non più all'altezza del proprio valore: evoluzione, non rivoluzione.",
          items: [
            "Audit dell'identità attuale",
            "Evoluzione del sistema visivo",
            "Riallineamento di tono e materiali",
            "Guidelines aggiornate",
          ],
        },
        {
          tag: "Direction",
          title: "Consulenza Strategica",
          desc: "Una sessione intensiva per mettere ordine: capire cosa non funziona e definire una roadmap chiara e attuabile.",
          items: [
            "Audit di comunicazione",
            "Sessione strategica 1:1",
            "Analisi della concorrenza",
            "Roadmap operativa",
          ],
        },
      ],
    },
    process: {
      label: "[ Capitolo 04 — Come lavoro ]",
      heading: "Un processo in tre atti.",
      items: [
        {
          chip: "Kick-off",
          title: "Discovery & Brief",
          desc: "Un'intervista approfondita per capire obiettivi, mercato e personalità del brand. Da qui nasce tutto il resto.",
        },
        {
          chip: "Direzione",
          title: "Allineamento Strategico",
          desc: "Moodboard, direzione creativa e architettura di marca: ci allineiamo sulla visione prima di progettare.",
        },
        {
          chip: "Delivery",
          title: "Progettazione su Misura",
          desc: "Esecuzione sartoriale, linee guida operative e consegna di ogni asset, pronto a essere usato con coerenza.",
        },
      ],
    },
    portfolio: {
      label: "[ Capitolo 05 — Portfolio ]",
      heading: "Lavori selezionati.",
      note: "Progetti reali per attività e brand: identità complete, marchi su misura e sperimentazione visiva. Apri una scheda per vedere il progetto da vicino.",
      deliverablesLabel: "Cosa ho progettato",
      items: [
        {
          id: "cesare",
          cardTitle: "Cesare",
          title: "Cesare",
          cat: "Food & beverage",
          meta: "Modena",
          cover: "/assets/cesare-cover.jpg",
          desc: "Un tradizionale bar di quartiere, oggi gestito da tre giovani titolari che ne hanno mantenuto l'essenza portando nuova energia. L'identità gioca con l'ironia — «Gli astemi non meritano l'Olimpo» — e con un immaginario mitologico pop: menù a tema sempre diversi, shopper, t-shirt e cup da asporto.",
          deliverables: ["Logo & identità visiva", "Menù a tema rotante", "Shopper & packaging", "Merchandising"],
          gallery: [
            { src: "/assets/cesare-menu.jpg" },
            { src: "/assets/cesare-shopper.jpg" },
            { src: "/assets/cesare-tshirt.jpg" },
          ],
        },
        {
          id: "nero",
          cardTitle: "Nero Forte",
          title: "Nero Forte — Tattoo & Piercing",
          cat: "Tattoo studio",
          meta: "Vignola",
          cover: "/assets/nero-cover.jpg",
          desc: "Studio di tatuaggi e piercing specializzato in blackwork. Il wordmark gotico, l'insegna scultorea e il packaging della crema aftercare costruiscono un'atmosfera raffinata e decisa, dove ogni dettaglio riflette competenza tecnica e sensibilità artistica.",
          deliverables: ["Logo & wordmark", "Insegna & applicazioni", "Packaging aftercare", "Merchandising"],
          gallery: [
            { src: "/assets/nero-hoodie.jpg" },
            { src: "/assets/nero-lanyard.jpg" },
            { src: "/assets/nero-cream.jpg" },
          ],
        },
        {
          id: "logofolio",
          cardTitle: "Logofolio",
          title: "Logofolio — Quattro marchi su misura",
          cat: "Logo design",
          meta: "Vari clienti",
          cover: "/assets/logofolio-cover.jpg",
          contain: true,
          desc: "Quattro marchi disegnati per realtà molto diverse: la firma elegante di una fotografa, un B&B immerso nella natura, un'azienda di domotica e un corso di bartending anti-spreco. Stili diversi, stesso metodo.",
          deliverables: ["Alberta Rivi — Fotografa", "Dimora Pani e Tulipani — B&B", "Smartotum — Domotica", "No Waste — Bartending"],
          gallery: [
            { src: "/assets/logofolio-alberta.jpg", caption: "Alberta Rivi — Fotografa" },
            { src: "/assets/logofolio-dimora.jpg", caption: "Dimora Pani e Tulipani — B&B" },
            { src: "/assets/logofolio-smartotum.jpg", caption: "Smartotum — Domotica" },
            { src: "/assets/logofolio-nowaste.jpg", caption: "No Waste — Bartending" },
          ],
        },
        {
          id: "collage",
          cardTitle: "Photo & Digital Collage",
          title: "Photo & Digital Collage",
          cat: "Editing & digital art",
          meta: "Progetto personale",
          cover: "/assets/collage-cover.jpg",
          desc: "Sperimentazione visiva tra photo editing e collage digitale: composizioni surreali che mescolano fotografia, texture e immaginario pop vintage.",
          deliverables: ["Photo editing", "Digital collage", "Composizione visuale"],
          gallery: [
            { src: "/assets/collage-1.jpg" },
            { src: "/assets/collage-2.jpg" },
            { src: "/assets/collage-3.jpg" },
          ],
        },
      ],
    },
    footer: {
      label: "[ Capitolo finale — Parliamone ]",
      lines: [
        [{ t: "Pronto a trasformare" }],
        [{ t: "la " }, { t: "percezione", a: true }],
        [{ t: "del tuo brand?" }],
      ],
      sub: "Trenta minuti, zero impegno: ci conosciamo, capiamo dove sei e dove vuoi arrivare.",
      cta: "Prenota una Call Conoscitiva",
      emailLabel: "Scrivimi",
      igLabel: "Instagram",
      igFeed: "Gli ultimi lavori su Instagram",
      back: "Torna su",
      legal: "© 2026 studio noom® — Tutti i diritti riservati.",
      tagline: "Brand design strategico, fatto su misura.",
      bio: {
        label: "Chi sono",
        greeting: "Ciao, sono Giorgia!",
        paragraphs: [
          "Ho passato gli ultimi 8 anni tra studi di progettazione, laboratori di produzione ed eventi prima di creare Studio Noom. Volevo uno spazio per poter lavorare a modo mio, dove il design non è una cornice ma strategia pura.",
          "Ho visto attività e professionisti straordinari restare invisibili e pagare le conseguenze di una comunicazione disordinata, frammentata e anonima. Il mio compito è mettere ordine.",
          "Trasformo l'identità visiva del tuo brand in un sistema solido, contemporaneo e duraturo, pensato per valorizzare quello che fai e per farti riconoscere subito come il vero punto di riferimento del tuo settore.",
        ],
        role: "Giorgia Sgarbi — Founder & Brand Designer",
      },
    },
  },
  en: {
    nav: {
      links: [
        { id: "#valore", num: "01", label: "Vision" },
        { id: "#metodo", num: "02", label: "Method" },
        { id: "#servizi", num: "03", label: "Services" },
        { id: "#processo", num: "04", label: "Process" },
        { id: "#portfolio", num: "05", label: "Portfolio" },
      ],
      cta: "Book a call",
    },
    hero: {
      tag: "Strategic brand design studio · Modena, IT",
      lines: [
        [{ t: "I turn identities" }],
        [{ t: "into images" }],
        [{ t: "that " }, { t: "speak.", a: true }],
      ],
      sub: "For professional firms, service businesses and lifestyle brands looking not for decoration, but for an identity that raises perceived market value.",
      primary: "Book a Discovery Call",
      secondary: "Explore the method",
      meta: "Brand identity · Positioning · Creative direction",
      scroll: "Scroll to explore",
    },
    marquee: [
      "Visual strategy",
      "Perceived value",
      "Bespoke care",
      "Trust",
      "Method",
      "Awareness",
      "Recognisability",
    ],
    manifesto: {
      label: "[ Chapter 01 — The problem ]",
      lines: [
        [{ t: "Messy communication" }],
        [{ t: "devalues", a: true }, { t: " your price" }],
        [{ t: "before you even quote it." }],
      ],
      body: "The market judges in seconds. If your image is fragmented — an improvised logo, incoherent socials, disconnected materials — the real value of your work never comes across. And your price pays for it.",
      body2: "My job is to bring order: a strategic identity that restores authority, makes the brand recognisable and supports the value of what you offer.",
      before: {
        title: "Before",
        items: [
          "Fragmented, improvised image",
          "Amateur perception, even when you're a pro",
          "Prices you struggle to justify",
        ],
      },
      after: {
        title: "After — with studio noom",
        items: [
          "A strategic identity, consistent everywhere",
          "Instant authority in your client's eyes",
          "A sustainable, credible premium price",
        ],
      },
      quote: "Branding is not decoration. It is business strategy that raises perceived value.",
    },
    values: {
      label: "[ Chapter 02 — Why me ]",
      heading: "Four pillars, one method.",
      items: [
        {
          title: "Listening",
          desc: "Trust grows from listening and transparency. I take the time to truly understand who's in front of me before drawing a single line.",
        },
        {
          title: "Structured method",
          desc: "No improvisation: a clear process, explained simply, guided step by step from kick-off to delivery.",
        },
        {
          title: "Eye for detail",
          desc: "Every brand deserves bespoke attention, whatever its size. No project is ever left on its own.",
        },
        {
          title: "Strategy before aesthetics",
          desc: "Beauty without direction doesn't sell. First we define who you are and who you speak to, then how you look.",
        },
      ],
    },
    services: {
      label: "[ Chapter 03 — Services ]",
      heading: "Three ways to work together.",
      cta: "Request information",
      items: [
        {
          tag: "From scratch",
          title: "Full Brand Identity",
          desc: "A complete identity built from the foundations up: strategy, visual system and guidelines made to last.",
          items: [
            "Positioning & strategy",
            "Logo system & typography",
            "Palette and guidelines",
            "Stationery & digital assets",
          ],
        },
        {
          tag: "Rebrand",
          title: "Strategic Brand Refresh",
          desc: "For established brands whose image no longer matches their value: evolution, not revolution.",
          items: [
            "Audit of current identity",
            "Evolution of the visual system",
            "Realignment of tone and materials",
            "Updated guidelines",
          ],
        },
        {
          tag: "Direction",
          title: "Strategic Consultancy",
          desc: "An intensive session to bring order: understand what isn't working and define a clear, actionable roadmap.",
          items: [
            "Communication audit",
            "1:1 strategy session",
            "Competitor analysis",
            "Operational roadmap",
          ],
        },
      ],
    },
    process: {
      label: "[ Chapter 04 — How I work ]",
      heading: "A process in three acts.",
      items: [
        {
          chip: "Kick-off",
          title: "Discovery & Brief",
          desc: "An in-depth interview to understand goals, market and the brand's personality. Everything else starts here.",
        },
        {
          chip: "Direction",
          title: "Strategic Alignment",
          desc: "Moodboard, creative direction and brand architecture: we align on the vision before designing.",
        },
        {
          chip: "Delivery",
          title: "Tailored Design",
          desc: "Bespoke execution, operating guidelines and delivery of every asset, ready to be used consistently.",
        },
      ],
    },
    portfolio: {
      label: "[ Chapter 05 — Portfolio ]",
      heading: "Selected works.",
      note: "Real projects for businesses and brands: full identities, bespoke marks and visual experimentation. Open a card to see the project up close.",
      deliverablesLabel: "What I designed",
      items: [
        {
          id: "cesare",
          cardTitle: "Cesare",
          title: "Cesare",
          cat: "Food & beverage",
          meta: "Modena",
          cover: "/assets/cesare-cover.jpg",
          desc: "A traditional neighbourhood bar, now run by three young owners who kept its soul while bringing new energy. The identity plays with irony — 'The teetotallers don't deserve Olympus' — and a pop-mythological imagery: ever-changing themed menus, shoppers, t-shirts and takeaway cups.",
          deliverables: ["Logo & visual identity", "Rotating themed menus", "Shoppers & packaging", "Merchandising"],
          gallery: [
            { src: "/assets/cesare-menu.jpg" },
            { src: "/assets/cesare-shopper.jpg" },
            { src: "/assets/cesare-tshirt.jpg" },
          ],
        },
        {
          id: "nero",
          cardTitle: "Nero Forte",
          title: "Nero Forte — Tattoo & Piercing",
          cat: "Tattoo studio",
          meta: "Vignola",
          cover: "/assets/nero-cover.jpg",
          desc: "A tattoo & piercing studio specialising in blackwork. The gothic wordmark, sculptural signage and aftercare cream packaging build a refined, decisive atmosphere where every detail reflects technical skill and artistic sensibility.",
          deliverables: ["Logo & wordmark", "Signage & applications", "Aftercare packaging", "Merchandising"],
          gallery: [
            { src: "/assets/nero-hoodie.jpg" },
            { src: "/assets/nero-lanyard.jpg" },
            { src: "/assets/nero-cream.jpg" },
          ],
        },
        {
          id: "logofolio",
          cardTitle: "Logofolio",
          title: "Logofolio — Four bespoke marks",
          cat: "Logo design",
          meta: "Various clients",
          cover: "/assets/logofolio-cover.jpg",
          contain: true,
          desc: "Four marks designed for very different businesses: a photographer's elegant signature, a B&B surrounded by nature, a home-automation company and a no-waste bartending course. Different styles, same method.",
          deliverables: ["Alberta Rivi — Photographer", "Dimora Pani e Tulipani — B&B", "Smartotum — Home automation", "No Waste — Bartending"],
          gallery: [
            { src: "/assets/logofolio-alberta.jpg", caption: "Alberta Rivi — Photographer" },
            { src: "/assets/logofolio-dimora.jpg", caption: "Dimora Pani e Tulipani — B&B" },
            { src: "/assets/logofolio-smartotum.jpg", caption: "Smartotum — Home automation" },
            { src: "/assets/logofolio-nowaste.jpg", caption: "No Waste — Bartending" },
          ],
        },
        {
          id: "collage",
          cardTitle: "Photo & Digital Collage",
          title: "Photo & Digital Collage",
          cat: "Editing & digital art",
          meta: "Personal project",
          cover: "/assets/collage-cover.jpg",
          desc: "Visual experimentation between photo editing and digital collage: surreal compositions mixing photography, textures and vintage pop imagery.",
          deliverables: ["Photo editing", "Digital collage", "Visual composition"],
          gallery: [
            { src: "/assets/collage-1.jpg" },
            { src: "/assets/collage-2.jpg" },
            { src: "/assets/collage-3.jpg" },
          ],
        },
      ],
    },
    footer: {
      label: "[ Final chapter — Let's talk ]",
      lines: [
        [{ t: "Ready to transform" }],
        [{ t: "how your brand" }],
        [{ t: "is " }, { t: "perceived?", a: true }],
      ],
      sub: "Thirty minutes, no commitment: we get to know each other, where you are and where you want to go.",
      cta: "Book a Discovery Call",
      emailLabel: "Write to me",
      igLabel: "Instagram",
      igFeed: "Latest work on Instagram",
      back: "Back to top",
      legal: "© 2026 studio noom® — All rights reserved.",
      tagline: "Strategic brand design, tailor-made.",
      bio: {
        label: "About me",
        greeting: "Hi, I'm Giorgia!",
        paragraphs: [
          "I spent the last 8 years between design studios, production labs and events before creating Studio Noom. I wanted a space where I could work my own way, where design is not a frame but pure strategy.",
          "I've seen extraordinary businesses and professionals stay invisible, paying the price of messy, fragmented and anonymous communication. My job is to bring order.",
          "I turn your brand's visual identity into a solid, contemporary and lasting system, designed to highlight what you do and make you instantly recognisable as the true reference point in your field.",
        ],
        role: "Giorgia Sgarbi — Founder & Brand Designer",
      },
    },
  },
};
